<template>
  <IntersectionObserver
    id="interface-slider"
    :class="clsx('interface-slider-wrapper', { 'animations-disabled': !animationEnabled })"
    :animation-enabled="animationEnabled"
    active-class="interface-slider-observer"
    :once="true"
    once-class="interface-slider-observer--visible"
    :threshold="0.4"
    @animation-end="observerAnimationEnd"
  >
    <CarouselSliderBox
      class="interface-slider"
      id="interface-slider"
      orientation="horizontal"
      :slides-to-show="1"
      :gap="windowWidth <= 720 ? '10px' : 'auto'"
      :extra-slide-size="windowWidth <= 720 ? '5%' : '15%'"
      :infinite-loop="true"
      :autoplay="sliderAutoplay"
      :autoplay-interval="10000"
      :show-slider-controls="false"
      slider-pagination-class="interface-slider-pagination"
      :initial-slide="1"
    >
      <OrdersStatisticsSlide class="interface-slider__slide--orders-statistics" />
      <InsuranceCompaniesSlide class="interface-slider__slide--insurance-companies" />
      <OrdersSlide class="interface-slider__slide--orders" />
    </CarouselSliderBox>
  </IntersectionObserver>
</template>

<script>
import clsx from 'clsx';
import { mapGetters } from 'vuex';
import InsuranceCompaniesSlide from './insurance-companies-slide';
import OrdersSlide from './orders-slide';
import OrdersStatisticsSlide from './orders-statistics-slide';
import { IntersectionObserver } from '@/shared/ui/intersection-observer';
import { CarouselSliderBox } from '@/shared/ui/slider';

export default {
  props: {
    animationEnabled: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      sliderAutoplay: false,
    };
  },
  components: { CarouselSliderBox, OrdersStatisticsSlide, InsuranceCompaniesSlide, OrdersSlide, IntersectionObserver },
  computed: {
    ...mapGetters('layoutModule', ['windowWidth']),
  },
  methods: {
    clsx,
    observerAnimationEnd() {
      this.sliderAutoplay = true;
    },
  },
};
</script>

<style scoped lang="scss">
.interface-slider-wrapper {
  background-color: #FCFDFF;
  padding-bottom: 75px;
}

.interface-slider {
  padding-bottom: 70px;

  &__slide--orders-statistics {
    transform: scale(0.5);
    opacity: 0;
    animation: interface-slide-animation 0.5s linear forwards;
    animation-delay: 0.5s;
    animation-play-state: paused;
  }

  &__slide--insurance-companies {
    transform: scale(0.5);
    opacity: 0;
    animation: interface-slide-animation 0.5s linear forwards;
    animation-play-state: paused;
  }

  &__slide--orders {
    transform: scale(0.5);
    opacity: 0;
    animation: interface-slide-animation 0.5s linear forwards;
    animation-delay: 0.5s;
    animation-play-state: paused;
  }
}

.interface-slider-observer--visible {
  .interface-slider__slide--orders-statistics, .interface-slider__slide--insurance-companies, .interface-slider__slide--orders {
    animation-play-state: running;
  }
}

.animations-disabled,
.animations-disabled * {
  animation: none !important;
  animation-duration: 0s !important;
  animation-delay: 0s !important;
  transition: none !important;
}

.animations-disabled {
  .interface-slider__slide--orders-statistics,
  .interface-slider__slide--insurance-companies,
  .interface-slider__slide--orders {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes interface-slide-animation {
  from {
    transform: scale(0.5);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
